if(!customElements.get('plp-sub-categories')){
  class PlpSubCategories extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {}
    }

    initSlider() {
     if(!this.querySelector('[data-slider]')) return;

     this.options = {
       slidesPerView: 2.3,
       spaceBetween: 10,
       breakpoints: {
         750: {
           slidesPerView: 7,
           spaceBetween: 22,
         },
       },
      }

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.options);
    }

    connectedCallback() {
      this.initSlider();
    };
  }

  customElements.define('plp-sub-categories', PlpSubCategories);
}